import { BiSearch } from "react-icons/bi";
import { Input } from "../Input";

function SearchInput({
  value,
  setter,
  placeholder = "Search",
  customStyle,
  inputStyle,
  iconColor = "var(--search-icon-color)",
  parentCustomStyle,
}) {
  return (
    <Input
      setter={setter}
      value={value}
      customStyle={{
        borderRadius: "var(--btn-border-radius)",
        height: "100%",
        width: "100%",
        border: "1px solid var(--search-border-color) ",
        ...customStyle,
      }}
      inputStyle={{
        padding: "12px 50px 12px 12px",
        fontSize: "var(--fs-100)",
        border: "none",
        backgroundColor: "var(--background)",
        borderRadius: "var(--btn-border-radius)",
        ...inputStyle,
      }}
      parentCustomStyle={parentCustomStyle}
      placeholder={placeholder}
      rightIcon={
        <BiSearch
          size={22}
          color={iconColor}
          // style={{ marginBottom: "-4px" }}
        />
      }
    />
  );
}

export default SearchInput;
